<template>
  <dashboard-component>
    <h1>Page not found</h1>
  </dashboard-component>
</template>
